export default __webpack_public_path__ + "static/media/engineering_black_24dp.65996839.svg";